module.exports = __webpack_public_path__ + "img/search_active.ea16ccc4.svg";